module.exports = __webpack_public_path__ + "510-hero.png?becf8b3c79d3e9e70c14f4637b296fc3";